<template>
  <div>
    <collapse>
      <collapse-item>
        <h3 slot="title" class="mb-0">Lotes</h3>

        <ul class="list-group list-group-flush list my--3">
          <li v-for="plot in plots" :key="plot.id" class="list-group-item px-0">
            <div class="row align-items-center">
              <div class="col">
                <h4 class="mb-2">
                  <router-link v-if="$can('show', 'plots')" :to="{ name: 'PlotShow', params: { id: plot.id } }">
                    {{ plot.name }}
                  </router-link>
                  <p v-else>{{ plot.name }}</p>
                </h4>
                <div class="small">
                  <span>Variedad: &nbsp;</span>
                  <span>{{ plot.variety.name }}</span>
                  <div class="font-italic">{{ plot.campaign.name }}</div>
                </div>
                <div class="medium">{{ plot.hectares }} has.</div>
              </div>
              <div class="col">
                <div class="col">
                  <router-link :to="canUpdatePlot(plot)">
                    <badge v-if="plot.preEmergence" class="mb-0" type="primary">
                      <span v-if="plot.harvest">Producción</span>
                      <span v-else-if="plot.emergence">Emergencia</span>
                      <span v-else-if="plot.preEmergence">Pre-Emergencia</span>
                    </badge>
                    <badge v-else class="mb-0" type="danger"> sin seguimiento </badge>
                  </router-link>
                </div>
              </div>
              <div class="col-auto">
                <router-link
                  v-if="$can('show', 'plots')"
                  :to="{ name: 'PlotShow', params: { id: plot.id } }"
                  class="btn base-button btn-outline-info btn-sm"
                >
                  <i class="fas fa-eye"></i> VER DETALLES
                </router-link>
              </div>
            </div>
          </li>

          <li v-if="plots.length === 0" class="list-group-item px-0">
            <div class="row align-items-center">
              <div class="col">
                <h4 class="mb-0">Este campo no tiene lotes cargados.</h4>
              </div>
            </div>
          </li>
        </ul>
      </collapse-item>
    </collapse>
  </div>
</template>

<script>
import Collapse from '@/components/Collapse/Collapse';
import CollapseItem from '@/components/Collapse/CollapseItem';

export default {
  name: 'FieldPlots',
  components: {
    Collapse,
    CollapseItem,
  },

  props: {
    field: null,
  },

  data() {
    return {
      plots: [],
    };
  },

  created() {
    const parameters = {
      'filter[field]': this.field,
      include: ['campaign', 'variety'],
    };

    this.$services
      .resource('plots')
      .get(parameters)
      .then((res) => res.data.data)
      .then((data) => (this.plots = data.plots));
  },

  methods: {
    canUpdatePlot(plot) {
      return this.$can('update', 'plots') ? { name: 'PlotFollowUp', params: { id: plot.id } } : {};
    },
  },
};
</script>
